import { styled } from '@mui/material/styles';

import {
  Box,
  FormControl,
  MenuItem,
  Typography
} from '@mui/material';
import { createGlobalStyle } from 'styled-components';

import DefaultTheme from '../../../../../../theme/DefaultTheme';

export const MultiSelectorGlobalStyle = createGlobalStyle`
  .MuiPaper-root {
    scrollbar-width: thin;
  }

  .base-Popper-root {
    background-color: ${DefaultTheme.colors.highClearGray};
    padding: 16px;
    
    & > .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation1.MuiAutocomplete-paper {
      border: 1px solid ${DefaultTheme.colors.clearGray};
      background:  ${DefaultTheme.colors.primaryWhite};
      border-radius: 6px;
    }
  }
`;

export const StyledFormControl = styled(FormControl)(({ theme }) => ({
  width: '100%',
  marginBottom: theme.spacing(2),

  '& .MuiOutlinedInput-root': {
    maxHeight: 'none',
    minHeight: '40px',
    borderRadius: '6px',
    backgroundColor: DefaultTheme.colors.white,

    '& fieldset': {
      borderWidth: '1px',
      borderColor: 'rgba(0, 0, 0, 0.23)'
    },

    '&:hover fieldset': {
      borderColor: 'rgba(0, 0, 0, 0.87)'
    },

    '&.Mui-focused fieldset': {
      borderWidth: '2px',
      borderColor: DefaultTheme.colors.brightNavyBlue
    }
  },

  '& .MuiInputBase-root': {
    backgroundColor: DefaultTheme.colors.primaryWhite,
    padding: '0 9px !important',

    '&  .MuiButtonBase-root.MuiChip-root.MuiChip-filled.MuiChip-sizeMedium.MuiChip-colorDefault.MuiChip-deletable.MuiChip-deletableColorDefault.MuiChip-filledDefault.MuiAutocomplete-tag.MuiAutocomplete-tagSizeMedium':{
      background: 'transparent !important',
      border: `1px solid ${DefaultTheme.colors.clearGray}`
    }
  },

  '& .MuiAutocomplete-tag': {
    maxHeight: '25px !important'
  },

  '& .search-icon': {
    fill: DefaultTheme.colors.clearGray,
    transition: 'none',
  },

  '& .MuiAutocomplete-popupIndicator': {
    transform: 'none',
  }

}));

export const ItemWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-items: center;
  align-items: center;
  padding: 8px;
`;

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(1, 2),
  fontFamily: DefaultTheme.fonts.family.inter,
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    fontFamily: DefaultTheme.fonts.family.inter,
  }
}));

export const ItemName = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontFamily: DefaultTheme.fonts.family.inter,
}));

export const ItemDescription = styled(Typography)(({ theme }) => ({
  fontSize: '12px',
  color: DefaultTheme.colors.darkGray,
  fontFamily: DefaultTheme.fonts.family.inter,
}));

export const ChipsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(0.5),
}));

export const ChipContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  fontFamily: DefaultTheme.fonts.family.inter,
}));

export const ChipName = styled('span')(({ theme }) => ({
  fontWeight: 600,
  fontFamily: DefaultTheme.fonts.family.inter,
}));

export const ChipValue = styled('span')(({ theme }) => ({
  fontSize: '0.875rem',
  fontWeight: '400',
  color: DefaultTheme.colors.black,
  fontFamily: DefaultTheme.fonts.family.inter,
}));

export const StyledPaper = styled('div')(({ theme }) => ({
  backgroundColor: DefaultTheme.colors.highClearGray,
  '& .MuiPaper-root': {
    backgroundColor: DefaultTheme.colors.highClearGray,
    boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)'
  }
}));

export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 224,
      width: 250,
      backgroundColor: DefaultTheme.colors.highClearGray,
    },
    className: 'custom-menu-paper'
  },
  classes: {
    paper: 'custom-menu-paper'
  },
  MenuListProps: {
    style: {
      backgroundColor: DefaultTheme.colors.highClearGray,
    }
  }
};